import * as devisConf from '@/configuration/devisConf';
import gestionDateBase from '@/services/general/gestionDateBase';
import genererIntervenant from '@/services/devisCommandes/genererIntervenant';

export function initializePostGet(facture) {
  facture.echeancierPaiement.sort();
  facture.echeancierPaiement.forEach((el) => {
    el.dateEcheance = gestionDateBase(el.dateEcheance);
  });
  facture.rapprochements.forEach((rapprochement) => {
    rapprochement.isIntoActualSearch = true;
    rapprochement.montantAffecter = 0;
  });
  facture.lignesCommande.forEach((ligne) => { ligne.selected = false; });
  facture.dateDevisCommande = gestionDateBase(facture.dateDevisCommande);
}

export function initializeDefault(facture, agences) {
  facture.aRapprocher = true;
  facture.etat = devisConf.ETAT_BROUILLON;
  facture.escompte = false;
  facture.penalite = false;
  facture.rapprochements = [];
  facture.avoirsAffectes = [];
  facture.recouvrement = false;
  if (facture.intervenants.length === 0) {
    const intervenant = genererIntervenant();
    intervenant.destinataireComptable = true;
    intervenant.repartition = 100;
    intervenant.destinataire = true;
    intervenant.annonceur = true;
    intervenant.payeur = true;
    facture.intervenants.push(intervenant);
  }
  if (agences.length === 1) {
    facture.agenceId = agences[0].agenceId;
  }
}

export function initializeCommandeAchatRapprochement(rapprochements, factureId) {
  rapprochements.forEach((rapprochement) => {
    rapprochement.montantAffecter = 0;
    rapprochement.isIntoActualSearch = true;
    rapprochement.echeanciers.forEach((echeancier) => {
      const montants = echeancier.echeancierLignes
        .filter((ligne) => ligne.factureId === factureId)
        .reduce((acc, ligne) => acc + ligne.montant, 0);
      rapprochement.montantAffecter += montants;
    });
  });

  return rapprochements.reduce((acc, rapprochement) => {
    const index = acc.findIndex((c) => c.id === rapprochement.id);
    if (index === -1) acc.unshift(rapprochement);
    return acc;
  }, []);
}
